import styled, { css } from 'styled-components';
import {
  isMobileStyleMixin,
  styleMixinInvertedFocusOutline,
} from '@amzn/storm-ui';

export const UtilityNavContainer = styled.div`
  display: flex;
  align-items: center;
  margin-inline-start: auto;
  padding-inline: ${({ theme }) => theme.spacing.base.default};
  gap: ${({ theme }) => theme.spacing.xxsmall.default};
  ${isMobileStyleMixin(css`
    padding: 0;
  `)};
`;

export const ExternalSwitchWrapper = styled.span`
  display: inline-flex;
  padding-inline-end: ${({ theme }) => theme.spacing.small.default};

  & label {
    color: ${({ theme }) => theme.header.contextBar.foreground};
  }

  & button {
    :focus-visible {
      ${styleMixinInvertedFocusOutline};
    }
  }

  ${isMobileStyleMixin(css`
    padding: ${({ theme }) =>
      `${theme.spacing.xxsmall.mobile} ${theme.spacing.xxxsmall.mobile}`};
  `)};
`;
